module.exports = __webpack_public_path__ + "static/media/c6bannerModul2_small.66c99897.jpg";